import React from "react";

export default function FieldFormula_InlineValueNotEmpty(props:any) {

    const valueClasses = Classes("ui5-txt-default", "fl-ac", "min-h-36", "p-l-10", "p-r-10", props.className)

    return (
        <React.Fragment>
            <div className={valueClasses} onClick={props.onClick}>
                {_.get(props.field.components, 'ValueIcon', false)}
                {_.get(props.field.components, 'ValuePrefix', false)}
                {props.field.getDisplayValue(props.value)}
            </div>
            {props.children}
        </React.Fragment>
    );
}
